import { cn } from "@synthesis/shared-utils";

import { CREATE_APPLICATION_TYPE_OPTIONS, type CreateApplicationCategory } from "../../create-application-page.lib";

type ApplicationTypeOptionCardProps = {
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
  className?: string;
};

export const ApplicationTypeOptionCard = ({ title, description, selected, onSelect, className }: ApplicationTypeOptionCardProps) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    onClick={onSelect}
    className={cn("bg-neutrals-white flex w-full flex-col gap-4 rounded-[14px] px-6 py-8 text-left transition-colors", className)}
  >
    <div className="flex items-start gap-4">
      <span
        className={cn(
          "mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full border-2",
          selected ? "border-brand-40 bg-brand-40" : "border-neutrals-80 bg-neutrals-95",
        )}
        aria-hidden
      >
        {selected && <span className="bg-neutrals-white size-2.5 rounded-full" />}
      </span>

      <span className="text-type-common heading-h4 text-2xl leading-8">{title}</span>
    </div>

    <p className="paragraph-base text-type-minor text-xl leading-8">{description}</p>
  </button>
);

type CreateApplicationTypeStepProps = {
  selectedCategory: CreateApplicationCategory | null;
  onSelectCategory: (category: CreateApplicationCategory) => void;
  className?: string;
};

export const CreateApplicationTypeStep = ({ selectedCategory, onSelectCategory, className }: CreateApplicationTypeStepProps) => (
  <div className={cn("flex flex-col gap-4", className)} role="radiogroup" aria-label="Тип заявки">
    <div className="grid gap-4 lg:grid-cols-2">
      {CREATE_APPLICATION_TYPE_OPTIONS.map((option) => (
        <ApplicationTypeOptionCard
          key={option.value}
          title={option.title}
          description={option.description}
          selected={selectedCategory === option.value}
          onSelect={() => onSelectCategory(option.value)}
        />
      ))}
    </div>
  </div>
);
